// import Swiper from 'swiper'
// import { Navigation, Pagination } from 'swiper/modules';

import lazyLoad from "../utils/lazy";

const cSustainability = () => {

  const slider = new Swiper('.sustainability__slider', {
    // modules: [Navigation, Pagination],
    spaceBetween: 0,
    pagination: {
      el: ".slide-pagination-numeric",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + "</span>";
      },
    },
  })
  
  slider.on('slideChange, init', function () {
    lazyLoad()
  });
}

export default cSustainability
